import i18next, { createInstance, type i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";

import enLocale from "../../locales/en.json";

const APP_LOCALE = "en";

export async function initI18n() {
  await initI18next(i18next);
}

export async function initSSR18n(): Promise<I18nInstance> {
  const instance = createInstance();
  await initI18next(instance);
  return instance;
}

async function initI18next(instance: I18nInstance) {
  if (instance.isInitialized) {
    await instance.changeLanguage(APP_LOCALE);
    return instance;
  }

  return await instance.use(initReactI18next).init({
    debug: import.meta.env.DEV,
    lng: APP_LOCALE,
    fallbackLng: APP_LOCALE,
    supportedLngs: [APP_LOCALE],
    resources: {
      en: {
        translation: enLocale,
      },
    },
    interpolation: {
      // React escapes values by default.
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });
}
